import { Box, Image, Stack, Text, VStack } from "@chakra-ui/react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Logo from "../../../assets/colorLogo.png";

const Categories = () => {
  const { subjects } = useSelector((state) => state.public);
  const categories = [
    { name: "National department" },
    { name: "American department for sat or act or est" },
    { name: "IG department" },
    { name: "College  department for courses" },
  ];
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        // className={className}
        style={{
          ...style,
          display: "block",
          width: "fit-content",
          bottom: "-7px",
          position: "absolute",
          left: "58%",
        }}
        onClick={onClick}
      >
        <FaArrowRight size={22} />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        // className={className}
        style={{
          ...style,
          display: "block",
          width: "fit-content",
          bottom: "-7px",
          position: "absolute",
          right: "58%",
          zIndex: "10000000",
        }}
        onClick={onClick}
      >
        <FaArrowLeft size={22} />
      </div>
    );
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    variableWidth: true,
    appendDots: (dots) => (
      <div
        style={{
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "16px",
          height: "16px",
          background: "#8196df",
          borderRadius: "50%",
        }}
      ></div>
    ),

    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <VStack gap={6} h="100%" w="100%" alignItems="flex-start" my={20}>
      <Text
        fontSize="32px"
        color="main_2"
        textAlign="center"
        fontWeight="700"
        textTransform="uppercase"
        w="100%"
      >
        Parent category
      </Text>
      <Slider {...settings} className="slider">
        {categories?.map((data, index) => {
          return (
            <Box
              key={index}
              w="280px !important"
              bg="blackAlpha.200"
              padding={5}
              h="300px"
              borderRadius={16}
              alignItems="center"
              justifyContent="center"
              display="flex !important"
              flexDirection="column"
              role="group"
            >
              <Image
                src={Logo}
                alt="Green double couch with wooden legs"
                borderRadius="full"
                w="100%"
                h="100px"
                objectFit="fill"
                _groupHover={{
                  transform: "scale(1.2)",
                  transition: "500ms ease-in-out",
                }}
              />
              <Stack mt="4" spacing="3" textAlign="center">
                <Text>{data?.name}</Text>
              </Stack>
            </Box>
          );
        })}
      </Slider>
    </VStack>
  );
};

export default Categories;
